'use client'

import { APOLLO_CLIENT_SIDE_OPTIONS } from '@/lib/apollo/clients/apolloClient.client'
import { useIsAuthenticated } from '@/lib/auth/client/AuthProvider.client'
import { isSSR } from '@/lib/next/services/nextjs.rendering'
import { useQuery } from '@apollo/client'
import { gql } from '@gql-generated/gql'
import { ProductFavoriteStatusDocument } from '@gql-generated/graphql'

gql(/* GraphQL */ `
  query productFavoriteStatus($reference: String!) {
    productByReference(reference: $reference) {
      reference # important to refresh the product in apollo cache
      isFavorite
    }
  }
`)

type UseProductFavoriteStatusReturnType = {
  loading: boolean
  data: boolean | undefined
}

export function useProductFavoriteStatus(reference: string): UseProductFavoriteStatusReturnType {
  const isAuthenticated = useIsAuthenticated()
  const { data, loading } = useQuery(ProductFavoriteStatusDocument, {
    ...APOLLO_CLIENT_SIDE_OPTIONS,
    variables: {
      reference,
    },
    skip: !reference || !isAuthenticated || isSSR,
  })

  return {
    loading,
    data: data?.productByReference?.isFavorite,
  }
}
